import React, { Fragment, useState } from 'react';
import axios from 'axios'
import Qs from 'qs';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledCarousel, Row, Col, Card, Badge, Button } from 'reactstrap';
import image_1 from '../../assets/test/loading_small.jpg';
import { clearSession, getRealImageSrc } from '../../session';
import Swal from 'sweetalert2'
//<UncontrolledCarousel items={items} />

export default class HighLightInfo extends React.Component {

  constructor(props) {
    super(props);
    this.state = { items: [], numbers: [0, 1, 2, 3, 4, 5], lang_version: props.lang_version };
  }

  goToSingleEvent(id) {
    this.props.handleViewSingleEvent(id);
  }


  componentDidMount() {
    let session = window.localStorage;
    axios.post(session.ch_action_url + "/action/get_all_highlight_posts", Qs.stringify({
      token: session.ch_token
    })).then(res => {
      if (res.data.status === -1) {
        clearSession();
      }
      else if (res.data.status === 0) {
        Swal.fire(
          'Operation Failed!',
          res.data.info,
          'error');
        this.setState({ isLoading: false });

      }
      else {
        let items = res.data.data;
        let numbers = [];
        for (let i = 6; i > items.length; i--) {
          numbers.push(i);
        }
        this.setState({ items: items, numbers: numbers });
      }
    });
  }



  static getDerivedStateFromProps(props, state) {
    let new_state = {};
    let flag = false;
    if (props.lang_version !== state.lang_version) {
      new_state.lang_version = props.lang_version;
      flag = true;
    }

    if (flag) {
      return new_state;
    }
    return null;
  }

  render() {
    return (
      <Fragment>
        <Row id="highlights">
          {this.state.items.length > 0 && this.state.items.map(item => (
            <Col xl="4" lg="6">
              <Card className="card-transparent mb-5" onClick={() => this.goToSingleEvent(item.id)}>
                <a href="#/" onClick={e => e.preventDefault()} className="card-img-wrapper rounded card-box-hover-rise-alt">
                  <img src={item.images!==undefined&&item.images.length>0?getRealImageSrc(item.images[0].src):image_1} className="card-img-top rounded" alt="..." style={{ height: "255px" }} />
                </a>
                <div className="card-body text-center">
                  <h5 className="card-title px-2 font-weight-bold font-size-lg">{item.title}</h5>
                  <Button size="sm" outline color="first" className="hover-scale-sm btn-pill mt-1">{this.state.lang_version === "en" ? "View Details" : "前往查看"}</Button>
                </div>
              </Card>
            </Col>
          ))}

          {this.state.numbers.length > 0 && this.state.numbers.map(number => (
            <Col xl="4" lg="6">
              <Card className="card-transparent mb-5">
                <a href="#/" onClick={e => e.preventDefault()} className="card-img-wrapper rounded card-box-hover-rise-alt">
                  <img src={image_1} className="card-img-top rounded" alt="..." />
                </a>
                <div className="card-body text-center">
                  <h5 className="card-title px-2 font-weight-bold font-size-lg">This is testing demo story</h5>
                  <Button size="sm" outline color="first" className="hover-scale-sm btn-pill mt-1">{this.state.lang_version === "en" ? "View Details" : "前往查看"}</Button>
                </div>
              </Card>
            </Col>
          ))}

        </Row>
      </Fragment>
    );
  }
}